var CryptoJS = require('crypto-js');
const key = 'dailidailidaili1';

// Encrypt

const AES = data =>
  CryptoJS.AES.encrypt(
    CryptoJS.enc.Utf8.parse(data),
    CryptoJS.enc.Utf8.parse(key),
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }
  ).toString();

export default AES;
